import { library } from '@fortawesome/fontawesome-svg-core';
import { App } from 'init/App';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lightgallery.css';
import ReactDOM from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { brand, duotone, light, regular, solid } from 'static/icons';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
library.add(light as any, solid as any, brand as any, regular as any, duotone as any);

// POLYFILLS
// Event.composedPath
// Possibly normalize to add window to Safari's chain, as it does not?
(function (E, d, w) {
    if (!E.composedPath) {
        E.composedPath = function () {
            if (this.path) {
                return this.path;
            }
            let target = this.target;

            this.path = [];
            while (target.parentNode !== null) {
                this.path.push(target);
                target = target.parentNode;
            }
            this.path.push(d, w);
            return this.path;
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
})(Event.prototype as any, document, window);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

// serviceWorker.register({
//     onUpdate: (registration) => {
//         console.log('New version found: RELOADING');
//         if (registration && registration.waiting) {
//             console.log('Registration');
//             registration.waiting.postMessage({ type: 'SKIP_WAITING' });
//         }
//         window.location.reload();
//     },
//     onSuccess: () => {
//         console.log('SW: on Success');
//     }
// });

try {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', function () {
            console.log('Unregistration service');
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                for (const registration of registrations) {
                    registration.unregister().then((bool) => {
                        console.log('unregister: ', bool);
                    });
                }
            });
        });
    }
} catch {
    console.log('Unable to work with service worker');
}
